var SIZE;
(function (SIZE) {
    SIZE["xs"] = "xs";
    SIZE["sm"] = "sm";
    SIZE["md"] = "md";
    SIZE["lg"] = "lg";
    SIZE["xl"] = "xl";
})(SIZE || (SIZE = {}));
var ALIGN;
(function (ALIGN) {
    ALIGN["center"] = "center";
    ALIGN["left"] = "left";
    ALIGN["right"] = "right";
})(ALIGN || (ALIGN = {}));
var TYPE;
(function (TYPE) {
    TYPE["success"] = "success";
    TYPE["information"] = "information";
    TYPE["error"] = "error";
    TYPE["warning"] = "warning";
    TYPE["legal-disclaimer"] = "legal-disclaimer";
})(TYPE || (TYPE = {}));

export { ALIGN as A, SIZE as S, TYPE as T };
